(ns manage.adset-decision-tree-page.tagging-and-trackers.tracker.db
  (:require [clojure.string :as str]
            [common.util :as util]
            [common.validators.core :refer [url?]]
            [manage.adset.hooks :as adset-hooks]
            [mate.core :as mc]
            [re-frame.core :as rf]
            [uix.core :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(rf/reg-sub ::tracker-params
  (fn [db _]
    (::tracker-params db)))

(defn invalid-tracker-url-error? [tracker-params index]
  (let [param-value (or (get-in tracker-params [index :value]) "")]
    (not (url? param-value))))

(defn redundant-click-tracker-indices [tracker-params]
  (when-some [first-click-tracker-index (-> (for [[index {:keys [type]}] (mc/seq-indexed tracker-params)
                                                  :when (= type "click")]
                                              index)
                                            first)]
    (->> tracker-params
         (keep-indexed (fn [index {:keys [type]}]
                         (when (and (= type "click")
                                    (> index first-click-tracker-index))
                           index)))
         set)))

(defn only-1-click-tracker-error? [redundant-indices index]
  (contains? redundant-indices index))

(defn can-save-trackers? [tracker-params]
  (let [redundant-indices (redundant-click-tracker-indices tracker-params)]
    (and (empty? redundant-indices)
         (every? (fn [index]
                   (and (not (only-1-click-tracker-error? redundant-indices index))
                        (not (invalid-tracker-url-error? tracker-params index))))
                 (range (count tracker-params))))))

(rf/reg-sub ::invalid-tracker-url-error-message
  :<- [::tracker-params]
  (fn [tracker-params [_ index]]
    (invalid-tracker-url-error? tracker-params index)))

(rf/reg-sub ::redundant-click-tracker-indices
  :<- [::tracker-params]
  (fn [tracker-params _]
    (redundant-click-tracker-indices tracker-params)))

(rf/reg-sub ::only-1-click-tracker-error
  :<- [::redundant-click-tracker-indices]
  (fn [redundant-click-tracker-indices [_ index]]
    (only-1-click-tracker-error? redundant-click-tracker-indices index)))

(defhook use-can-save-trackers []
  (let [tracker-params (use-subscribe [::tracker-params])]
    (can-save-trackers? tracker-params)))

(rf/reg-event-db ::add-tracker-param
  (fn [db _]
    (update db ::tracker-params (fnil conj []) {:type "click", :value nil})))

(rf/reg-event-db ::delete-tracker-param
  (fn [db [_ index]]
    (update db ::tracker-params util/vec-dissoc index)))

(rf/reg-event-db ::set-tracker-type
  (fn [db [_ index attribute]]
    (assoc-in db [::tracker-params index :type] attribute)))

(rf/reg-event-db ::set-tracker-value
  (fn [db [_ index value]]
    (assoc-in db [::tracker-params index :value] value)))
